import React from 'react';

import {
  FormInput,
  FormLabel,
  FormInputHolder,
  FormDateInput,
  FormTimeInput
} from '../../form';

export default () => (
  <div>
    <FormInputHolder>
      <FormInput
        name="amount"
        labelRenderer={() => (<FormLabel for="amount" note="Optional">Amount</FormLabel>)}
        measurement={'ml'}
        initialValue='100.0'
        type="number"
        maxLength={6}
      />
    </FormInputHolder>

    <FormInputHolder>
      <FormDateInput
        name="date"
        type="date"
        labelRenderer={() => (<FormLabel for="date">Date</FormLabel>)}
        dateFormat="MMM, dd yyyy"
      />

      <FormTimeInput
        name="startTime"
        labelRenderer={() => (<FormLabel for="startTime">Time</FormLabel>)}
      />
    </FormInputHolder>
  </div>
)